module.exports = __webpack_public_path__ + "static/media/rmb.32efdf49.svg";